import React, { useMemo } from "react";

const STATUS = {
  message: "message",
  reply: "reply",
  paid: "paid",
  notPaid: "notPaid",
  shipped: "shipped",
  notShipped: "notShipped",
  received: "received",
};

function fmt(date, locale = undefined) {
  if (!date) return "";
  try {
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(date));
  } catch {
    return new Date(date).toLocaleString();
  }
}

const TransactionCommentFeed = ({ transaction, t, reverse = false, locale }) => {
  const items = useMemo(() => {
    const pushIf = (arr, cond, item) => cond && arr.push(item);

    const out = [];
    pushIf(out, !!transaction?.Comments, {
      date: transaction?.Date,
      text: transaction?.Comments,
      label: t("Buyer Message"),
      role: "buyer",
      kind: STATUS.message,
    });

    pushIf(out, !!transaction?.AnswerComments, {
      date: transaction?.AnswerDate,
      text: transaction?.AnswerComments,
      label: t("Seller Reply"),
      role: "seller",
      kind: STATUS.reply,
    });

    pushIf(out, !!transaction?.MarkedAsPaidDate, {
      date: transaction?.MarkedAsPaidDate,
      text: transaction?.MarkedAsPaidComments,
      label: t("Marked as Paid"),
      role: "buyer",
      kind: STATUS.paid,
    });

    pushIf(out, !!transaction?.MarkedAsNotPaidDate, {
      date: transaction?.MarkedAsNotPaidDate,
      text: transaction?.MarkedAsNotPaidComments,
      label: t("Marked as Not Paid"),
      role: "seller",
      kind: STATUS.notPaid,
    });

    pushIf(out, !!transaction?.MarkedAsShippedDate, {
      date: transaction?.MarkedAsShippedDate,
      text: transaction?.MarkedAsShippedComments,
      label: t("Marked as Shipped"),
      role: "seller",
      kind: STATUS.shipped,
    });

    pushIf(out, !!transaction?.MarkedAsNotShippedDate, {
      date: transaction?.MarkedAsNotShippedDate,
      text: transaction?.MarkedAsNotShippedComments,
      label: t("Marked as Not Shipped"),
      role: "buyer",
      kind: STATUS.notShipped,
    });

    pushIf(out, !!transaction?.MarkedAsReceivedDate, {
      date: transaction?.MarkedAsReceivedDate,
      text: null,
      label: t("Marked as Received"),
      role: "buyer",
      kind: STATUS.received,
    });

    out.sort((a, b) => new Date(a.date) - new Date(b.date));
    return reverse ? out.reverse() : out;
  }, [transaction, t, reverse]);

  if (!items.length) return null;

  return (
    <ul className="tc">
      {items.map((it, i) => (
        <li key={i} className={`tc-item role-${it.role} kind-${it.kind}`}>
          <div className="tc-rail">
            <span className="tc-dot" aria-hidden />
          </div>

          <div className="tc-card">
            <div className="tc-head">
              <span className="tc-chip tc-label">{it.label}</span>
              <span className={`tc-chip tc-role`}>{it.role === "buyer" ? t("Buyer") : t("Seller")}</span>
              <time className="tc-date">{fmt(it.date, locale)}</time>
            </div>

            {it.text ? <p className="tc-text">{it.text}</p> : null}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default TransactionCommentFeed;
